@use "~theme/typography";
@use "~theme/breakpoints";

.container {
  width: auto;
}

.container p {
  @include typography.body;
  text-align: center;
  margin-bottom: 1em;
}

.container strong {
  font-weight: var(--semibold-weight);
}

.header {
  @include typography.heading3;
  text-align: center;
  margin: 0;
}

.ctas {
  display: flex;
  margin-top: 32px;
  flex-wrap: wrap;

  @include breakpoints.desktop {
    flex-wrap: nowrap;
  }
}

.button {
  flex: 1;
  margin: 0 8px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}